import * as React from 'react';
import translate from '../../../../locale/translate';

import { formatDate } from '../../util/StringUtil';
import ISettings from './ISettings';

import { PM } from '../../../../interfaces';

interface IProps {
    title: string,
    software: PM.ISoftware[],
    settings: ISettings,
}

const STATE_TITLE = {
    INSTALLED: translate.gettext("INSTALLED"),
    PLANNED: translate.gettext("PLANNED"),
    FAILED: translate.gettext("FAILED"),
    BLOCKED: translate.gettext("BLOCKED"),
    UNPLANNED: translate.gettext("UNPLANNED"),
};

const STATE_EMPTY_MESSAGE = {
    INSTALLED: translate.gettext("No software has been installed"),
    PLANNED: translate.gettext("No software is planned for installation"),
    FAILED: translate.gettext("No software installation has failed"),
    BLOCKED: translate.gettext("No software is blocked"),
    UNPLANNED: translate.gettext("No unplanned software available"),
};

export default class SoftwareTable extends React.Component<IProps, {}> {
    static propTypes = {
        title: React.PropTypes.string.isRequired,
        software: React.PropTypes.array,
        settings: React.PropTypes.object.isRequired,
    };

    renderCategoryTable(state: string, software: PM.ISoftware[]) {
        let rows;

        if (!software || !software.length) {
            let key = `no-software-${state}`;
            rows = [
                <tr key={key}>
                    <td className="muted small" colSpan={2}>{STATE_EMPTY_MESSAGE[state]}</td>
                </tr>
            ];
        } else {
            rows = software.map((software: PM.ISoftware) => {
                return (
                    <tr key={software.patch.SoftwareId}>
                        <td className="small">{software.patch.Description || software.patch.SoftwareName}</td>
                        <td className="small text-right">{formatDate(software.date, 'L')}</td>
                    </tr>
                );
            });
        }

        return <table key={state} className="table">
            <thead>
                <tr>
                    <th className="small">{STATE_TITLE[state]}</th>
                    <th className="col-xs-2 text-right small">{translate.gettext("Date")}</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </table>;
    }

    render() {
        let softwareList = this.props.software;
        const { title, settings } = this.props;

        const byState = {
            INSTALLED: [],
            PLANNED: [],
            FAILED: [],
            BLOCKED: [],
            UNPLANNED: [],
        };

        let keys = Object.keys(byState);

        softwareList.forEach((software: PM.ISoftware) => {
            if (!byState[software.patchState]) {
                return console.warn(software);
            }
            byState[software.patchState].push(software);
        });

        if(!settings.displayStatesWithoutSoftware) {
            keys = keys.filter((key: string) => {
                return byState[key].length > 0;
            });
        }

        const children = keys.map((state: string) => {
            return this.renderCategoryTable(state, byState[state]);
        });

        return (
            <div>
                <h5>{title}</h5>
                {children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/pm/listSoftware/SoftwareTable.tsx